module.exports = __webpack_public_path__ + "img/fourth-section.212bfe85.webp";